var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackBubbleSolidIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6.25C3 5.00736 4.00736 4 5.25 4H18.75C19.9926 4 21 5.00736 21 6.25V15.7205C21 16.9631 19.9926 17.9705 18.75 17.9705H13.0073L9.3599 21.6313C8.57597 22.4181 7.2244 21.8691 7.2244 20.7503V17.9705H5.25C4.00736 17.9705 3 16.9631 3 15.7205V6.25ZM8.25 12.75C8.94036 12.75 9.5 12.1904 9.5 11.5C9.5 10.8096 8.94036 10.25 8.25 10.25C7.55964 10.25 7 10.8096 7 11.5C7 12.1904 7.55964 12.75 8.25 12.75ZM13.25 11.5C13.25 12.1904 12.6904 12.75 12 12.75C11.3096 12.75 10.75 12.1904 10.75 11.5C10.75 10.8096 11.3096 10.25 12 10.25C12.6904 10.25 13.25 10.8096 13.25 11.5ZM15.75 12.75C16.4404 12.75 17 12.1904 17 11.5C17 10.8096 16.4404 10.25 15.75 10.25C15.0596 10.25 14.5 10.8096 14.5 11.5C14.5 12.1904 15.0596 12.75 15.75 12.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackBubbleSolidIcon);
export default __webpack_public_path__ + "static/media/feedback-bubble-solid-icon.984503b13fc2aa46b59525459cd0b78c.svg";
export { ForwardRef as ReactComponent };